import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color", "strokeWidth"];
var __jsx = React.createElement;
import React from "react";
const ChevronLeftRightIcon = _ref => {
  let {
      size = "16",
      color = "currentColor",
      strokeWidth = "0.2"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7087 5.69757C11.0138 6.00267 11.0138 6.49733 10.7087 6.80243L5.0111 12.5L10.7087 18.1976C11.0138 18.5027 11.0138 18.9973 10.7087 19.3024C10.4036 19.6075 9.90892 19.6075 9.60382 19.3024L3.35382 13.0524C3.04873 12.7473 3.04873 12.2527 3.35382 11.9476L9.60382 5.69757C9.90892 5.39248 10.4036 5.39248 10.7087 5.69757Z",
    fill: color,
    stroke: color,
    strokeWidth: strokeWidth
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2913 5.69757C13.9862 6.00267 13.9862 6.49733 14.2913 6.80243L19.9889 12.5L14.2913 18.1976C13.9862 18.5027 13.9862 18.9973 14.2913 19.3024C14.5964 19.6075 15.0911 19.6075 15.3962 19.3024L21.6462 13.0524C21.9513 12.7473 21.9513 12.2527 21.6462 11.9476L15.3962 5.69757C15.0911 5.39248 14.5964 5.39248 14.2913 5.69757Z",
    fill: color,
    stroke: color,
    strokeWidth: strokeWidth
  }));
};
export default ChevronLeftRightIcon;